/**
 * Created by mzhao on 09/28/2021.
 * Description:
 * ExchangeImportCheckDialog Component
 * ------ maintenance history ------
 */
import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { catchError, filter, take } from 'rxjs/operators';
import { ExchangeImportDataModel } from '../../../tamalelibs/models/exchange-import.model';
import { ExchangeService } from '../../../tamalelibs/services/exchange.service';
import { NotificationStyles } from '../../../widgets/notification/notification.model';
import { ToastService } from '../../../widgets/toast/toast.service';
import { ExchangeListDialogOptions } from '../exchange-import-list-dialog/exchange-import-list-dialog.model';
import { ExchangeImportListDialogService } from '../exchange-import-list-dialog/exchange-import-list-dialog.service';
import { ExchangeDialogOptions } from './exchange-import-check-dialog.model';
import { ExchangeImportCheckDialogService } from './exchange-import-check-dialog.service';
import { of as observableOf } from 'rxjs';

@Component({
    selector: 'tam-exchange-import-check-dialog',
    templateUrl: './exchange-import-check-dialog.component.html',
    styleUrls: ['./exchange-import-check-dialog.component.scss']
})
export class ExchangeImportCheckDialogComponent implements OnInit, OnDestroy {
    //#region public properties
    dialogWidth = 684;
    exchangeList = new Array();
    exchangeData;
    headerTip = 'We found below contacts from Exchange, do you want pull them into Tamale ?';
    isOpened: boolean;
    isSelectAll = false;
    isProgressing = false;
    titleName = 'Import Contacts from Exchange';
    //#endregion

    //#region private properties

    /**
    * the subscription array that would be unsubscribed on destroying.
    */
    private _destroySubscriptions: Array<Subscription> = [];

    //#endregion

    constructor(
        private _exchangeImportCheckDialogService: ExchangeImportCheckDialogService,
        private _exchangeImportListDialogService: ExchangeImportListDialogService,
        private _exchangeService: ExchangeService,
        private _toast: ToastService,
    ) { }


    //#region public methods

    ngOnInit() {
        this._destroySubscriptions.push(
            this._exchangeImportCheckDialogService.dialogOpen$.pipe(
                filter(action => !this.isOpened),
            ).subscribe((dialogOpenOptions: ExchangeDialogOptions) => {
                this._exchangeService.getExchangeImportContactList()
                    .pipe(
                        catchError((error) => {
                            this._toast.notify({
                                style: NotificationStyles.Error,
                                message: error.message
                            });
                            return observableOf(null);
                        }),
                        take(1),
                    ).subscribe(data => {
                        if (data) {
                            this.exchangeData = data;
                            this.exchangeList = data.contacts;
                            if (this.exchangeList.length > 0) {
                                this.isOpened = true;
                            } else {
                                this._toast.notify({
                                    style: NotificationStyles.Info,
                                    message: 'No data available for import.'
                                });
                            }
                            if (this.exchangeList.findIndex(element => !element.select) === -1) {
                                this.isSelectAll = true;
                            }
                        }
                    });
            }),
            this._exchangeImportCheckDialogService.dialogClose$.subscribe(item => {
                this._closeDialog();
            }));
    }


    ngOnDestroy(): void {
        this._destroySubscriptions.forEach(subscription => subscription.unsubscribe());
        this._destroySubscriptions = [];
    }

    /**
     * import exchange contact which are checked.
     *
     * @memberof ExchangeImportCheckDialogComponent
     */
    clickNextButton() {
        this.isProgressing = true;
        this._exchangeService.exchangeDuplicateWithTamale(this.exchangeData)
            .pipe(
                catchError((error) => {
                    this._toast.notify({
                        style: NotificationStyles.Error,
                        message: error.message
                    });
                    this.isProgressing = false;
                    return observableOf(null);
                }),
                take(1),
                filter(res => !!res)
            )
            .subscribe(data => {
                this.isProgressing = false;
                const _data = ExchangeImportDataModel.parse(data);
                const duplicateCounts = _data.contacts.findIndex(element => element.duplicates && element.duplicates.length > 0);
                if (duplicateCounts > -1) {
                    const exchangeListDialogOptions = new ExchangeListDialogOptions();
                    exchangeListDialogOptions.data = _data;
                    this._exchangeImportListDialogService.dialogOpen$.next(exchangeListDialogOptions);
                } else {

                    this._exchangeService.postExchangeImportContactList(_data).subscribe(() => {
                        this._toast.notify({
                            style: NotificationStyles.Info,
                            message: `Importing in progress, you will be notified when it's done.`
                        });
                        this._closeDialog();
                    });
                }
            });

    }

    /**
     * Disable import button if no item check.
     *
     * @returns
     * @memberof ExchangeImportCheckDialogComponent
     */
    isSelectOne() {
        return this.isProgressing && this.exchangeData && this.exchangeData.contacts && this.exchangeData.contacts.findIndex(element => element.select) === -1;
    }

    /**
     * Check list logic.
     *
     * @param {*} item
     * @memberof ExchangeImportCheckDialogComponent
     */
    onClickCheckItem(item) {
        if (this.exchangeData.contacts.findIndex(element => !element.select) === -1) {
            this.isSelectAll = true;
        } else {
            this.isSelectAll = false;
        }
    }

    /**
     * Check all item logic
     *
     * @memberof ExchangeImportCheckDialogComponent
     */
    onClickSelectAll() {
        this.exchangeData.contacts.forEach(element => {
            element.select = this.isSelectAll;
        });
    }

    onCancelBtnClick(event?) {
        this._closeDialog();
    }

    //#endregion

    //#region private methods
    private _closeDialog() {
        this.isOpened = false;
        this.exchangeData = null;
        this.isSelectAll = false;
    }
    //#endregion
}
